import { NgxWebstorageModule } from 'ngx-webstorage';

import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import { UiKitModule } from '@ui-kit';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { SharedModule } from './shared/shared.module';
import { RootComponent } from './root.component';
import { BookACallComponent } from './public/book-a-call/book-a-call.component';
import { GlobalErrorHandler } from './global-error-handler';

@NgModule({
  declarations: [
    AppComponent,
    RootComponent,
    BookACallComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
    }),
    NgxWebstorageModule.forRoot(),
    // DeviceDetectorModule.forRoot(),
    UiKitModule.forRoot(environment),
    SharedModule.forRoot(),
  ],
  providers: [
    AppService,
    { provide: Window, useValue: window },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
  bootstrap: [RootComponent],
})
export class AppModule { }
